<template>
    <div class="calendar-bottom-bar">
        <p aria-live="polite" class="calendar-from-price body-bold"></p>
        <div class="calendar-bottom-bar__top">
            <p class="calendar-currency-notice small-text"></p>
            <p role="alert" aria-live="polite" class="calendar-legend-error small-text validationError" style="display:none;"> {{ textNoAvailability }} </p>
        </div>
        <div class="calendar-legend" role="list">
            <div class="legend-item" role="listitem">
                <span class="box--square box--minimum_stay_dates" aria-hidden="true"></span>
                <span class="small-text">{{ textMinStay }}</span>
            </div>
            <div class="legend-item" role="listitem">
                <span class="box--square box--no_checkin__dates datepicker__month-day--no-checkin" aria-hidden="true"></span>
                <span class="small-text">{{ textNoCheckin }}</span>
            </div>
            <div class="legend-item" role="listitem">
                <span class="box--square box--no_checkout_dates datepicker__month-day--no-checkout" aria-hidden="true"></span>
                <span class="small-text">{{ textNoCheckout }}</span>
            </div>
            <div class="legend-item" role="listitem">
                <span class="box--square box--calendar-event" aria-hidden="true"></span>
                <span class="small-text">{{ textCalendarEvent }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CalendarLegend',
    props: {
        i18n: { type: Object, default: () => ({}) },
    },
    computed: {
        textNoAvailability() {
            return this.i18n.no_availability ?? 'There are no rooms available for your selected dates.';
        },
        textMinStay() {
            return this.i18n.min_stay ?? 'Minimum Stay Dates';
        },
        textNoCheckin() {
            return this.i18n.no_checkin ?? 'No Check-in Dates';
        },
        textNoCheckout() {
            return this.i18n.no_checkout ?? 'No Check-out Dates';
        },
        textCalendarEvent() {
            return this.i18n.calendar_event ?? 'Special Event Dates';
        },
    },
};
</script>
